import { motion } from "framer-motion";
import { Shield, HardDrive, Lock, Radio } from "lucide-react";

const trustPoints = [
  {
    icon: HardDrive,
    title: "Local-first architecture",
    description: "Your machine is the source of truth. Sessions run on your hardware. We don't host your code.",
  },
  {
    icon: Lock,
    title: "Encrypted transport",
    description: "All communication between your Mac and phone is encrypted end-to-end. Direct connection when possible.",
  },
  {
    icon: Shield,
    title: "Secure pairing",
    description: "Phone and desktop pair via a cryptographic handshake. No shared credentials, no cloud passwords.",
  },
  {
    icon: Radio,
    title: "Relay only when needed",
    description: "Direct peer-to-peer when on the same network. Encrypted relay only when you're on a different network.",
  },
];

export default function SecuritySection() {
  return (
    <section
      id="security"
      data-testid="security-section"
      className="py-24 px-6"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span
            className="text-xs uppercase tracking-wider mb-4 block"
            style={{
              color: "#A1A1AA",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "11px",
            }}
          >
            Security
          </span>
          <h2
            className="text-3xl sm:text-4xl font-semibold tracking-tight text-white"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Built for real developer trust.
          </h2>
          <p className="text-base mt-4" style={{ color: "#A1A1AA" }}>
            We take security seriously. Your code never leaves your machine
            unless you explicitly choose to share it.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px" style={{ background: "rgba(255,255,255,0.06)" }}>
          {trustPoints.map((point, i) => (
            <motion.div
              key={point.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="p-8"
              style={{ background: "#0A0A0A" }}
            >
              <point.icon
                className="w-5 h-5 mb-4"
                style={{ color: "#fff" }}
                strokeWidth={1.5}
              />
              <h3
                className="text-base font-medium text-white mb-2"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {point.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: "#71717A" }}>
                {point.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
